<script setup>
import {useReservationStore} from "../stores/reservation"

const reservationStore = useReservationStore()
import _ from 'lodash'

</script>
<template>

    <template v-if="!_.isNull(reservationStore.discount)">

        <div class="col-12 d-flex justify-content-end align-items-center">
            <h4 class="mb-0 me-2">{{ $t('reservation.price.subtotal') }}</h4>
            <h4 class="mb-0 text-right price">{{ reservationStore.discount.room_price.formatted }}</h4>
        </div>
        <div class="col-12 d-flex justify-content-end align-items-center">
            <h4 class="mb-0 me-2">{{ $t('reservation.price.discount') }}</h4>
            <h4 class="mb-0 text-right price">- {{ reservationStore.discount.discount.formatted }}</h4>
        </div>

        <div class="col-12 d-flex justify-content-end align-items-center">
            <h4 class="mb-0 me-2">{{ $t('reservation.price.total') }}</h4>
            <h3 class="mb-0 text-right price">{{ reservationStore.discount.discount_price.formatted }}</h3>
        </div>

    </template>

    <template v-if="_.isNull(reservationStore.discount)">

        <div class="col-12 d-flex justify-content-end align-items-center" v-if="!_.isNull(reservationStore.fundingLabel)">
            <h4 class="mb-0 me-2">{{ $t('reservation.price.covered_by') }}</h4>
            <h4 class="mb-0 text-right price">{{ reservationStore.fundingLabel }}</h4>
        </div>

        <div class="col-12 d-flex justify-content-end align-items-center">
            <h4 class="mb-0 me-2">{{ $t('reservation.price.total') }}</h4>
            <h4 class="mb-0 text-right price" v-if="reservationStore.paymentRequired">{{ reservationStore.payablePrice.formatted }}</h4>
            <h4 class="mb-0 text-right price" v-else>{{ $t('reservation.price.no_payment_required') }}</h4>
        </div>

        <div class="col-12 text-end mt-2" v-if="!_.isNull(reservationStore.pricingNotice)">
            <small>{{ reservationStore.pricingNotice }}</small>
        </div>

    </template>

</template>
